import React from 'react';
import {BackButton} from './';
import {isMobile} from 'mobile-device-detect';

const ProgressBar = ({questionIndex}) => (
    <footer className={isMobile ? `mobile` : `desktop`}>
        <nav>
            {Array(4).fill(0).map((_, i) => (
                <span key={`progress_bar_${i}`} className={i === (questionIndex - 1) ? `current` : ``}></span>
            ))}
            {questionIndex > 1 && <BackButton questionIndex={questionIndex} />}
        </nav>
    </footer>
);

export default ProgressBar;
